export class CopyContactPlanContactPlansDto {
  ContactPlanId: number;
  PlanName: string;

  constructor(init: any) {
    this.ContactPlanId = init.ContactPlanId;
    this.PlanName = init.PlanName;
  }
}
